import { FileText } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white\">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white sticky top-0 z-10\">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-3\">
          <a href="/\" className="flex items-center gap-2\" data-testid="privacy-logo-link\">
            <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center\">
              <FileText className="h-4 w-4 text-white\" />
            </div>
            <span className="font-semibold text-slate-900\">Canva For Resume</span>
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16\">
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2\" data-testid="privacy-heading\">
          Privacy Policy
        </h1>
        <p className="text-sm text-slate-500 mb-10\">Last updated: February 1, 2026</p>

        <div className="prose prose-slate max-w-none space-y-8\" data-testid="privacy-content\">
          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">1. Information We Collect</h2>
            <p className="text-slate-600 leading-relaxed\">
              We collect information you provide directly to us, including your name, email address, resume content, and job descriptions. When you make a purchase, payment information is processed securely by Razorpay and is not stored on our servers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">2. How We Use Your Information</h2>
            <p className="text-slate-600 leading-relaxed\">
              Your information is used solely to provide the resume optimization service. Resume content is sent to our AI processing pipeline for optimization and is not shared with third parties for marketing purposes. We may use anonymized, aggregated data to improve our service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">3. Data Storage and Security</h2>
            <p className="text-slate-600 leading-relaxed\">
              We implement industry-standard security measures to protect your personal information. Your data is stored securely using encrypted databases. We retain your data only for as long as necessary to provide the Service and comply with legal obligations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">4. Third-Party Services</h2>
            <p className="text-slate-600 leading-relaxed\">
              We use third-party services including Firebase for authentication, MongoDB for data storage, OpenAI for AI processing, and Razorpay for payment processing. Each of these services has their own privacy policies governing the use of your information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">5. Cookies and Tracking</h2>
            <p className="text-slate-600 leading-relaxed\">
              We use essential cookies to maintain your session and authentication state. We do not use third-party tracking cookies for advertising purposes. You can control cookie settings through your browser preferences.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">6. Your Rights</h2>
            <p className="text-slate-600 leading-relaxed\">
              You have the right to access, correct, or delete your personal data. You may request a copy of all data we hold about you. To exercise any of these rights, please contact us at the email address provided below.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">7. Children's Privacy</h2>
            <p className="text-slate-600 leading-relaxed\">
              Our Service is not intended for use by individuals under the age of 16. We do not knowingly collect personal information from children. If we become aware that we have collected data from a child, we will take steps to delete it promptly.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">8. Contact Us</h2>
            <p className="text-slate-600 leading-relaxed\">
              If you have any questions about this Privacy Policy, please contact us at privacy@tripleninelabs.com.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 py-6\">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-slate-500\">
          &copy;2026 Canva For Resume, a product of Triplenine Labs.
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
